import PropTypes from 'prop-types'
import React from 'react'
import { AdApi } from 'SRC/modules/ads/shared/api'
import { CookiesHelper } from 'Core/cookiesHelper/CookiesHelper'
import { setProfileAdsError, fetchUserInfo } from 'SRC/modules/users/Profile/actions'
import { updateAdById } from '../../../../actions'
import { connect } from 'react-redux'
import { adsStatues } from 'SRC/modules/ads/shared/constants'

export class TogglePause extends React.PureComponent {
  togglePause = async () => {
    if (this.props.isAvailable) {
      const helper = new CookiesHelper()
      const token = helper.get('token')
      const userId = helper.get('userId')
      const adId = this.props.adId
      if (token && userId && adId) {
        this.props.updateAdById(adId, {isLoading: true})
        const fields = {token, userId, adId}
        const api = new AdApi()
        const {status, message} = await api.togglePause(fields)
        if (status === AdApi.responseTypes.OK) {
          const adStatus = this.props.isPaused ? adsStatues.PUBLISHED.code : adsStatues.PAUSED.code
          this.props.updateAdById(adId, {status: adStatus, isLoading: false})
          this.props.fetchUserInfo(userId, token, true)
        } else {
          this.props.setProfileAdsError(message)
          this.props.updateAdById(adId, {isLoading: false})
        }
      }
    }
  }

  render () {
    const {isAvailable, isPaused} = this.props
    return (
      <div className={`moji-oglasi-akcije-item ${isAvailable ? `` : `disabled`}`}>
        <a href='javascript:void(0)' onClick={this.togglePause}><i className='ico-pauziraj-oglas ico' />
          {isPaused ? `Pauziran` : `Pauziraj`}
        </a>
      </div>
    )
  }
}

TogglePause.propTypes = {
  isAvailable: PropTypes.bool.isRequired,
  adId: PropTypes.number.isRequired,
  isPaused: PropTypes.bool.isRequired,
  updateAdById: PropTypes.func.isRequired,
  fetchUserInfo: PropTypes.func.isRequired,
  setProfileAdsError: PropTypes.func.isRequired
}

TogglePause.defaultProps = {
  isAvailable: true,
  isPaused: false
}

export default connect(null, {updateAdById, fetchUserInfo, setProfileAdsError})(TogglePause)
